import {
  faAtlas,
  faBlog,
  faBalanceScale,
  faBalanceScaleRight,
  faBezierCurve,
  faBoltLightning,
  faBoxes,
  faCalendarAlt,
  faChartBar,
  faChartPie,
  faClipboard,
  faClipboardList,
  faCompressArrowsAlt,
  faDollarSign,
  faFileContract,
  faFileInvoice,
  faFileLines,
  faFileMedicalAlt,
  faGroupArrowsRotate,
  faHandshake,
  faIdBadge,
  faInbox,
  faIndustry,
  faInfo,
  faListCheck,
  faMapMarkerAlt,
  faObjectGroup,
  faPenSquare,
  faProjectDiagram,
  faShip,
  faShippingFast,
  faStamp,
  faSync,
  faTools,
  faUserCog,
  faUserFriends,
  faUserPlus,
  faUserTag,
  faUserTie,
  faWaveSquare,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons'
import { UserPermission } from '@globaleris/ui.library'
import { NonAuthRoutes } from '..'
import {
  AllocationsPage,
  BalancePage,
  BuyAndSellPage,
  CapacityPage,
  FloatingConceptsAddPage,
  FloatingConceptsPage,
  TradesPage
} from '../../pages'
import { AddressInfoPage } from '../../pages/addresses/addresses'
import AllocationsEditPage from '../../pages/allocationsEdit/allocationsEdit'
import { AtlasDocumentsPage } from '../../pages/atlas/documents/atlasDocumentsPage'
import { AtlasBlogPage } from '../../pages/atlas/blog/atlasBlogPage'
import { AtlasBlogEditorPage } from '../../pages/atlas/blog/atlasBlogEditorPage'
import { CapacityAddPage } from '../../pages/capacity/add/add'
import { EditCapacityBundlePage } from '../../pages/capacity/edit/editBundle'
import { EditCapacityFormalizedPage } from '../../pages/capacity/edit/editFormalized'
import { EditCapacityNoBundlePage } from '../../pages/capacity/edit/editNoBundle'
import { ClientAddPage } from '../../pages/clients/add/client.add'
import { ClientPage } from '../../pages/clients/client'
import { ClientEditPage } from '../../pages/clients/edit/client.edit'
import { ClientFile } from '../../pages/clients/file/client.file'
import { ClientsSearchPage } from '../../pages/clients/search/clients.search'
import { ConceptPage } from '../../pages/clientsMod/concept/concept'
import { CupsPage } from '../../pages/clientsMod/cups/cups'
import { ClientsAddPage } from '../../pages/clientsMod/gestion/clientsAdd'
import { ClientsEditPage } from '../../pages/clientsMod/gestion/clientsEdit'
import { ClientsManagementPage } from '../../pages/clientsMod/gestion/clientsManagement'
import { ProductDataPage } from '../../pages/clientsMod/productData/productData'
import { CommercialPage } from '../../pages/commercial/clients/commercial'
import { CommercialEditPage } from '../../pages/commercial/clients/commercialEdit'
import { CommercialDetailsPage } from '../../pages/commercial/commercials/commercials.details'
import { CommercialsConceptPage } from '../../pages/commercial/conceptCommercial/commercialsConcept'
import { CommercialsProductDataPage } from '../../pages/commercial/productDataCommercial/commercialsProductData'
import { ComunicationCenterPage } from '../../pages/comunicationCenter'
import { ConceptsAddPage } from '../../pages/concepts/add/concepts.add'
import { ConceptModifiedAddPage } from '../../pages/concepts/conceptModified/add/conceptModified.add'
import { ConceptsPage } from '../../pages/concepts/concepts'
import { ConceptEditPage } from '../../pages/concepts/edit/concepts.edit'
import { ContactsInfoPage } from '../../pages/contactsInfo'
import { ContractAddPage } from '../../pages/contracts/add/contracts.add'
import { ContractCapacitiesPage } from '../../pages/contracts/capacities/contracts.capacities'
import { ContractChangeOwnerPage } from '../../pages/contracts/changeOwner/contracts.changeOwner'
import { ContractDetailsPage } from '../../pages/contracts/details/contracts.details'
import { ContractEditPage } from '../../pages/contracts/edit/contracts.edit'
import { ContractsFlexibilitiesPage } from '../../pages/contracts/flexibilities/contracts.flexibilities'
import { ContractOrdersPage } from '../../pages/contracts/ordering/contracts.orders'
import { ContractsPriceComponentsPage } from '../../pages/contracts/priceComponents/contracts.priceComponents'
import { ContractQuantitiesPage } from '../../pages/contracts/quantities/contracts.quantities'
import { CupsDetailsPage } from '../../pages/cups/details/cups.details'
import { MeterAddPage } from '../../pages/cups/meterAdd/cups.meter.add'
import { DashboardPage } from '../../pages/dashboard/dashboard'
import { DemandForecastCPPage } from '../../pages/demandForecast/demandForecastCP/demandForecastCP'
import { DemandForecastLPPage } from '../../pages/demandForecast/demandForecastLP/demandForecastLP'
import { DocumentsPage } from '../../pages/documents/documents'
import { FlexibilityAddPage } from '../../pages/flexibility/add/flexibilityAdd'
import { FlexibilityEditPage } from '../../pages/flexibility/edit/flexibilityEdit'
import { FlexibilityPage } from '../../pages/flexibility/flexibility'
import { VirtualBatteryDetailPage } from '../../pages/floatingConcepts/virtualBatteryDetail/virtualBatteryDetail'
import { GeneratorTest } from '../../pages/generatorTestPage/generatorTest'
import { AtrDistributionPage } from '../../pages/guarantees/atrDistribution/atrDistribution'
import { ConsultationInformationPage } from '../../pages/guarantees/information/consultationInformation'
import { UnbalancedGuaranteesPage } from '../../pages/guarantees/unbalancedGuarantees/unbalancedGuarantees'
import { InvoiceCyclesPage } from '../../pages/invoiceCycles/invoiceCycles'
import { InvoiceCyclesFinishedPage } from '../../pages/invoiceCycles/invoiceCyclesFinished/invoiceCycles.finished'
import { InvoiceCyclesNewPage } from '../../pages/invoiceCycles/invoiceCyclesNew'
import { InvoiceCyclesProcessingPage } from '../../pages/invoiceCycles/invoiceCyclesProcessing/invoiceCycles.processing'
import { InvoiceCycleReportPage } from '../../pages/invoiceCycles/invoiceCyclesReport/invoiceCycles.report'
import { InvoiceEditPage } from '../../pages/invoicesPage/edit/invoicePage.edit'
import { InvoicesPage } from '../../pages/invoicesPage/invoicesPage'
import { LeadsAddPage } from '../../pages/leads/add/leads.add'
import { LeadsEditPage } from '../../pages/leads/edit/leads.edit'
import { LeadsFilePage } from '../../pages/leads/file/leads.file'
import { LeadsPage } from '../../pages/leads/leads'
import { LeadsConsumptionProfilePage } from '../../pages/leads/profiles/consumption/profile/leads.consumption.profile'
import { LeadsProfileDetailPage } from '../../pages/leads/profiles/detail/lead.profiles.detail'
import { LeadsReportPage } from '../../pages/leads/report/leads.report'
import { ManualInvoicePage } from '../../pages/manualInvoice/manualInvoice'
import { ContractsLoadPage } from '../../pages/massiveProcess/contracts/contractsLoad'
import { DemandLoadPage } from '../../pages/massiveProcess/demand/demandLoad'
import { NominationPage } from '../../pages/nomination'
import { PriceComponentsAddPage } from '../../pages/priceComponents/add/priceComponentsAdd'
import { PriceComponentsPage } from '../../pages/priceComponents/PriceComponents'
import { PricingAddPage } from '../../pages/pricing/add/pricingAdd'
import { PricingEditPage } from '../../pages/pricing/edit/pricingEdit'
import { PriceComponentTypeAdd } from '../../pages/pricing/priceComponentType/priceComponentType.add'
import { PriceComponentTypeInstancesPage } from '../../pages/pricing/priceComponentType/priceComponentTypeInstances/priceComponentType.instances'
import { PricingPage } from '../../pages/pricing/pricing'
import { VersionsPage } from '../../pages/pricing/versions/versions'
import { AddProcedurePage } from '../../pages/procedures/procedures.add'
import { ProductsAddPage } from '../../pages/products/add/products.add'
import { CustomizeProductPage } from '../../pages/products/customize/products.customize'
import { ProductsEditPage } from '../../pages/products/edit/productsEdit'
import { ProductsPriceComponentsPage } from '../../pages/products/priceComponents/products.priceComponents'
import { ProductsPage } from '../../pages/products/products'
import { ProfileEditPage } from '../../pages/profiles/edit/profiles.edit'
import { ProfilesPage } from '../../pages/profiles/profiles'
import { QuotesProductsPage } from '../../pages/quotes/products/quotes.products'
import { QuotesPage } from '../../pages/quotes/quotes'
import { RegulatoryReportsPage } from '../../pages/regulatoryReports/regulatoryReports'
import { ReportsPage } from '../../pages/reports/reports'
import { SettlementGroupsPage } from '../../pages/settlementGroups'
import { SettlementGroupAggregatedAddPage } from '../../pages/settlementGroups/aggregatedAdd/settlementGroup.aggregatedAdd'
import { SettlementGroupAggregatedEditPage } from '../../pages/settlementGroups/aggregatedEdit/settlementGroup.aggregatedEdit'
import { ChildSettlementGroupPage } from '../../pages/settlementGroups/childSettlementGroups/settlementGroups.childSettlementGroups'
import { SettlementGroupContractsPage } from '../../pages/settlementGroups/contracts/settlementGroups.contracts'
import { SettlementGroupFlexibilitiesPage } from '../../pages/settlementGroups/flexibilities/settlementGroups.flexibitilities'
import { SettlementGroupSubjectsPage } from '../../pages/settlementGroups/subjects/settlementGroups.subjects'
import { SettlementsAnnulationPage } from '../../pages/settlements/annulation/settlements.annulation'
import { SettlementsInvoicesPage } from '../../pages/settlements/invoices/settlements.invoices'
import { SettlementsPage } from '../../pages/settlements/settlements'
import { ShipsPage } from '../../pages/ships'
import { ShipsAddPage } from '../../pages/ships/add'
import { ShipsEditPage } from '../../pages/ships/edit'
import { TanksAddPage } from '../../pages/tanks/add/tanks.add'
import { TanksEditPage } from '../../pages/tanks/edit/tanks.edit'
import { TanksPage } from '../../pages/tanks/tanks'
import { TaskAddPage } from '../../pages/tasks/add/tasks.add'
import { TaskEditPage } from '../../pages/tasks/edit/tasks.edit'
import { TasksPage } from '../../pages/tasks/tasks'
import { TemplateConfigurationPage } from '../../pages/templateConfiguration/templateConfiguration'
import { TemplateSettingsAddPage } from '../../pages/templateSettings/add'
import { TemplateSettingsEditPage } from '../../pages/templateSettings/edit'
import { TemplateSettingsPage } from '../../pages/templateSettings/templateSettings'
import { TradesAddPage } from '../../pages/trades/add/add'
import { TradesEditPage } from '../../pages/trades/edit/tradesEdit'
import { ConsultationPage } from '../../pages/wholesaler/consultation/consultation'
import { PartnerPage } from '../../pages/wholesaler/partners/partners'
import { PartnerEditPage } from '../../pages/wholesaler/partners/partnersEdit'
import { MarketerPage } from '../../pages/wholesaler/productsMay/marketer'
import { TraderPage } from '../../pages/wholesaler/trader/trader'
import { WidgetConfigurationPage } from '../../pages/widgetConfiguration/widgetConfiguration'
import { AtlasAccessPage } from '../../pages/atlas/accessAtlas/atlasAccessPage'

interface Page {
  resource: Resources[]
  path: string
  icon?: IconDefinition
  component: React.FC<any>
  userPermission?: UserPermission
}

export enum Pages {
  Balance,
  BuyAndSell,
  Nominations,
  Capacities,
  CapacityAdd,
  CapacityEdit,
  CapacityEditBundle,
  CapacityEditFormalized,
  Allocations,
  AllocationsEdit,
  Ships,
  ShipsAdd,
  ShipsEdit,
  ComunicationCentre,
  Trades,
  TradesEditPage,
  TradesAddPage,
  RegulatoryReport,
  DemandForecastingGeneric,
  Pricing,
  PricingAdd,
  PricingEdit,
  PricingComponentTypeAdd,
  PricingComonentTypeInstances,
  InvoiceCycles,
  InvoiceCyclesNew,
  InvoiceCycleProcessing,
  InvoiceCycleFinished,
  InvoiceCycleReport,
  TanksAdd,
  TanksEdit,
  Tanks,
  Flexibility,
  FlexibilityAdd,
  FlexibilityEdit,
  Dashboard,
  Reports,
  Invoiceslist,
  ConfiguradorConceptos,
  ConfiguradorPlantillas,
  ProductsMin,
  ConceptsMin,
  CUPS,
  CupsDetails,
  MeterAdd,
  CustomerInvoices,
  ConceptsMay,
  ProductsMay,
  Trader,
  Counterparties,
  CounterpartiesEdit,
  CommercialsProductData,
  CommercialsConcept,
  ConsultationInformation,
  MPDemand,
  MPContracts,
  UnbalancedGuarantees,
  AtrDistribution,
  Cisternas,
  Commercial,
  CommercialEdit,
  Commercials,
  ProductsCom,
  ConceptsCom,
  Mayoristas,
  Guarantee,
  Gbalance,
  Gatr,
  InfoTSO,
  WidgetConfiguration,
  TemplateConfiguration,
  FloatingConcepts,
  FloatingConceptsAdd,
  TemplateSettings,
  InvoicesPage,
  InvoicesEdit,
  TemplateSettingsEdit,
  TemplateSettingsAdd,
  MassiveProcess,
  DemandForecastingLP,
  DemandForecastingCP,
  ManualInvoice,
  Versions,
  ClientsManagement,
  Clients,
  ClientsSearch,
  ClientsAdd,
  ClientsEdit,
  Client,
  ClientEdit,
  ClientAdd,
  ClientFile,
  ContractsAdd,
  ContractsEdit,
  ContractCapacities,
  ContractDetails,
  ContractQuantities,
  ContractFlexibilities,
  ContractPriceComponents,
  ContractChangeOwnerPage,
  ContractOrdersPage,
  ContactsInfo,
  AddressInfo,
  ProceduresAdd,
  CommercialsDetails,
  GeneratorTest,
  SettlementGroups,
  SettlementGroupFlexibilities,
  SettlementGroupContracts,
  SettlementGroupSubjects,
  SettlementGroupChild,
  SettlementGroupAggregatedAdd,
  SettlementGroupAggregatedEdit,
  PriceComponents,
  PriceComponentsAdd,
  Products,
  ProductsAdd,
  ProductsEdit,
  ProductsPrice,
  ProductsCustomize,
  Documents,
  Concepts,
  ConceptsAdd,
  ConceptsEdit,
  ConceptsModifiedAdd,
  VirtualBatteryDetail,
  Leads,
  LeadsAdd,
  LeadsEdit,
  LeadsFile,
  LeadsReport,
  LeadsProfileDetail,
  LeadsConsumptionProfile,
  Quotes,
  QuotesProducts,
  Tasks,
  TaskEdit,
  TaskAdd,
  Profiles,
  ProfilesAdd,
  ProfilesEdit,
  Settlements,
  SettlementsInvoices,
  SettlementsAnnulation,
  Atlas,
  Documentos,
  AccessAtlas,
  AtlasBlog,
  BlogAdd,
  BlogEdit
}

export enum Resources {
  Dashboard = 24,
  Reports = 24,
  ComunicationsCenterFiles = 25,
  ComunicationsCenterSends = 26,
  ComunicationsCenterExternals = 27,
  ComunicationsCenterProcedures = 28,
  Balance = 29,
  BuyAndSell = 30,
  Nomination = 31,
  Capacity = 32,
  Allocations = 33,
  Tanks = 34,
  Ships = 35,
  InfoTSO = 36,
  Guarantee = 37,
  DemandForecasting = 38,
  Client = 39,
  Trades = 40,
  TradesPioneer = 41,
  Commercial = 42,
  Pricing = 43,
  InvoiceCycles = 44,
  InvoicesPage = 45,
  TemplateSettings = 46,
  FloatingConcepts = 47,
  InformesRegulatorios = 48,
  massiveProcess = 49,
  Flexibility = 50,
  NewTrades = 51,
  Administration = 53,
  GroupedBilling = 54,
  VirtualBattery = 55,
  Leads = 56,
  ExtendedClients = 57,
  Tasks = 58,
  BalanceActions = 59,
  Profiles = 60,
  SVA = 1060,
  Ciclosfacturacionnew = 2060,
  AtlasDocumentos = 3060
}

export const Routes: Map<Pages, Page> = new Map([
  [
    Pages.Balance,
    {
      resource: [Resources.Balance],
      icon: faBalanceScale,
      path: NonAuthRoutes.balance,
      component: BalancePage
    }
  ],
  [
    Pages.BuyAndSell,
    {
      resource: [Resources.BuyAndSell],
      icon: faHandshake,
      path: NonAuthRoutes.buyAndSell,
      component: BuyAndSellPage
    }
  ],
  [
    Pages.Nominations,
    {
      resource: [Resources.Nomination],
      icon: faCalendarAlt,
      path: NonAuthRoutes.nomination,
      component: NominationPage
    }
  ],
  [
    Pages.CapacityAdd,
    {
      resource: [Resources.Capacity],
      path: NonAuthRoutes.capacityAdd,
      component: CapacityAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.CapacityEditBundle,
    {
      resource: [Resources.Capacity],
      path: NonAuthRoutes.capacityEditBundle,
      component: EditCapacityBundlePage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.CapacityEditFormalized,
    {
      resource: [Resources.Capacity],
      path: NonAuthRoutes.capacityEditFormalized,
      component: EditCapacityFormalizedPage
    }
  ],
  [
    Pages.CapacityEdit,
    {
      resource: [Resources.Capacity],
      path: NonAuthRoutes.capacityEdit,
      component: EditCapacityNoBundlePage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.Capacities,
    {
      resource: [Resources.Capacity],
      icon: faCompressArrowsAlt,
      path: NonAuthRoutes.capacity,
      component: CapacityPage
    }
  ],
  [
    Pages.AllocationsEdit,
    {
      resource: [Resources.Allocations],
      path: NonAuthRoutes.allocationsEdit,
      component: AllocationsEditPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.Allocations,
    {
      resource: [Resources.Allocations],
      icon: faProjectDiagram,
      path: NonAuthRoutes.allocations,
      component: AllocationsPage
    }
  ],
  [
    Pages.ShipsAdd,
    {
      resource: [Resources.Ships],
      path: NonAuthRoutes.shipsAdd,
      component: ShipsAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ShipsEdit,
    {
      resource: [Resources.Ships],
      path: NonAuthRoutes.shipsEdit,
      component: ShipsEditPage
    }
  ],
  [
    Pages.Ships,
    {
      resource: [Resources.Ships],
      icon: faShip,
      path: NonAuthRoutes.ships,
      component: ShipsPage
    }
  ],
  [
    Pages.ComunicationCentre,
    {
      resource: [
        Resources.ComunicationsCenterFiles,
        Resources.ComunicationsCenterSends,
        Resources.ComunicationsCenterExternals,
        Resources.ComunicationsCenterProcedures
      ],
      icon: faInbox,
      path: NonAuthRoutes.comunicationCenter,
      component: ComunicationCenterPage
    }
  ],
  // [
  //   Pages.TradesSimpleAdd,
  //   {
  //     resource: [Resources.Pricing],
  //     path: NonAuthRoutes.tradesSimpleAdd,
  //     component: TradeAddPage,
  //     userPermission: UserPermission.EDIT
  //   }
  // ],
  [
    Pages.TradesAddPage,
    {
      resource: [Resources.Trades],
      path: NonAuthRoutes.tradesAdd,
      component: TradesAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.TradesEditPage,
    {
      resource: [Resources.Trades],
      path: NonAuthRoutes.tradesEdit,
      component: TradesEditPage
    }
  ],

  [
    Pages.Trades,
    {
      resource: [Resources.Trades],
      icon: faCompressArrowsAlt,
      path: NonAuthRoutes.trades,
      component: TradesPage
    }
  ],
  [
    Pages.RegulatoryReport,
    {
      resource: [Resources.InformesRegulatorios],
      icon: faFileInvoice,
      path: NonAuthRoutes.regulatoryReports,
      component: RegulatoryReportsPage
    }
  ],
  [
    Pages.DemandForecastingGeneric,
    {
      resource: [Resources.DemandForecasting],
      icon: faChartBar,
      path: NonAuthRoutes.demandForecastingLP,
      component: DemandForecastLPPage
    }
  ],
  [
    Pages.DemandForecastingLP,
    {
      resource: [Resources.DemandForecasting],
      icon: faChartBar,
      path: NonAuthRoutes.demandForecastingLP,
      component: DemandForecastLPPage
    }
  ],
  [
    Pages.DemandForecastingCP,
    {
      resource: [Resources.DemandForecasting],
      icon: faChartBar,
      path: NonAuthRoutes.demandForecastingCP,
      component: DemandForecastCPPage
    }
  ],
  [
    Pages.PricingAdd,
    {
      resource: [Resources.Pricing],
      path: NonAuthRoutes.pricingAdd,
      component: PricingAddPage
    }
  ],
  [
    Pages.PricingEdit,
    {
      resource: [Resources.Pricing],
      path: NonAuthRoutes.pricingEdit,
      component: PricingEditPage
    }
  ],
  [
    Pages.PricingComponentTypeAdd,
    {
      resource: [Resources.Pricing],
      path: NonAuthRoutes.priceComponentTypeAdd,
      component: PriceComponentTypeAdd
    }
  ],
  [
    Pages.PricingComonentTypeInstances,
    {
      resource: [Resources.Pricing],
      path: NonAuthRoutes.priceComponentTypeInstances,
      component: PriceComponentTypeInstancesPage
    }
  ],
  [
    Pages.Versions,
    {
      resource: [Resources.Pricing],
      path: NonAuthRoutes.versions,
      component: VersionsPage
    }
  ],
  [
    Pages.Pricing,
    {
      resource: [Resources.Pricing],
      icon: faDollarSign,
      path: NonAuthRoutes.pricing,
      component: PricingPage
    }
  ],
  [
    Pages.FlexibilityEdit,
    {
      resource: [Resources.Flexibility],
      path: NonAuthRoutes.flexibilityEdit,
      component: FlexibilityEditPage
    }
  ],
  [
    Pages.FlexibilityAdd,
    {
      resource: [Resources.Flexibility],
      path: NonAuthRoutes.flexibilityAdd,
      component: FlexibilityAddPage
    }
  ],
  [
    Pages.Flexibility,
    {
      resource: [Resources.Flexibility],
      icon: faBezierCurve,
      path: NonAuthRoutes.flexibility,
      component: FlexibilityPage
    }
  ],
  [
    Pages.SettlementsAnnulation,
    {
      resource: [Resources.InvoicesPage],
      path: NonAuthRoutes.SettlementsAnnulation,
      component: SettlementsAnnulationPage
    }
  ],
  [
    Pages.SettlementsInvoices,
    {
      resource: [Resources.InvoicesPage],
      path: NonAuthRoutes.SettlementsInvoices,
      component: SettlementsInvoicesPage
    }
  ],
  [
    Pages.Settlements,
    {
      resource: [Resources.InvoicesPage],
      path: NonAuthRoutes.Settlements,
      component: SettlementsPage
    }
  ],
  [
    Pages.InvoiceCycleProcessing,
    {
      resource: [Resources.InvoiceCycles],
      icon: faSync,
      path: NonAuthRoutes.invoiceCycleProcessing,
      component: InvoiceCyclesProcessingPage
    }
  ],
  [
    Pages.InvoiceCycleFinished,
    {
      resource: [Resources.InvoiceCycles],
      icon: faSync,
      path: NonAuthRoutes.invoiceCycleFinished,
      component: InvoiceCyclesFinishedPage
    }
  ],
  [
    Pages.InvoiceCycleReport,
    {
      resource: [Resources.InvoiceCycles],
      icon: faSync,
      path: NonAuthRoutes.invoiceCycleReport,
      component: InvoiceCycleReportPage
    }
  ],
  [
    Pages.InvoiceCycles,
    {
      resource: [Resources.InvoiceCycles],
      icon: faSync,
      path: NonAuthRoutes.invoiceCycles,
      component: InvoiceCyclesPage
    }
  ],
  [
    Pages.InvoiceCyclesNew,
    {
      resource: [Resources.InvoiceCycles],
      icon: faSync,
      path: NonAuthRoutes.invoiceCyclesNew,
      component: InvoiceCyclesNewPage
    }
  ],
  [
    Pages.Dashboard,
    {
      resource: [Resources.Dashboard],
      icon: faChartPie,
      path: NonAuthRoutes.dashboard,
      component: DashboardPage
    }
  ],
  [
    Pages.Reports,
    {
      resource: [Resources.Reports],
      icon: faChartBar,
      path: NonAuthRoutes.reports,
      component: ReportsPage
    }
  ],
  [
    Pages.InvoicesEdit,
    {
      resource: [Resources.InvoicesPage],
      path: NonAuthRoutes.InvoicesEdit,
      component: InvoiceEditPage
    }
  ],
  [
    Pages.InvoicesPage,
    {
      resource: [Resources.InvoicesPage],
      icon: faFileInvoice,
      path: NonAuthRoutes.InvoicesPage,
      component: InvoicesPage
    }
  ],
  [
    Pages.ConfiguradorConceptos,
    {
      resource: [Resources.TemplateSettings],
      icon: faTools,
      path: NonAuthRoutes.widgetConfiguration,
      component: WidgetConfigurationPage
    }
  ],
  [
    Pages.TemplateConfiguration,
    {
      resource: [Resources.TemplateSettings],
      icon: faFileContract,
      path: NonAuthRoutes.templateConfiguration,
      component: TemplateConfigurationPage
    }
  ],
  [
    Pages.TanksAdd,
    {
      resource: [Resources.Tanks],
      path: NonAuthRoutes.tanksAdd,
      component: TanksAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.TanksEdit,
    {
      resource: [Resources.Tanks],
      path: NonAuthRoutes.tanksEdit,
      component: TanksEditPage
      //userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.Tanks,
    {
      resource: [Resources.Tanks],
      icon: faShippingFast,
      path: NonAuthRoutes.tanks,
      component: TanksPage
    }
  ],
  [
    Pages.VirtualBatteryDetail,
    {
      resource: [Resources.VirtualBattery],
      path: NonAuthRoutes.virtualBatteryDetail,
      component: VirtualBatteryDetailPage
    }
  ],
  [
    Pages.FloatingConceptsAdd,
    {
      resource: [Resources.FloatingConcepts, Resources.VirtualBattery, Resources.BalanceActions],
      path: NonAuthRoutes.floatingConceptsAdd,
      component: FloatingConceptsAddPage
    }
  ],
  [
    Pages.FloatingConcepts,
    {
      resource: [Resources.FloatingConcepts, Resources.VirtualBattery, Resources.BalanceActions],
      icon: faShip,
      path: NonAuthRoutes.floatingConcepts,
      component: FloatingConceptsPage
    }
  ],
  [
    Pages.ClientsAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faUserCog,
      path: NonAuthRoutes.clientsModAdd,
      component: ClientsAddPage
    }
  ],
  [
    Pages.ClientsEdit,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.clientsModEdit,
      component: ClientsEditPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.Clients,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faUserCog,
      path: NonAuthRoutes.clientsMod,
      component: ClientsManagementPage
    }
  ],
  [
    Pages.MeterAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.MeterAdd,
      component: MeterAddPage
    }
  ],
  [
    Pages.CupsDetails,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faMapMarkerAlt,
      path: NonAuthRoutes.CupsDetails,
      component: CupsDetailsPage
    }
  ],
  [
    Pages.CUPS,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faMapMarkerAlt,
      path: NonAuthRoutes.Cups,
      component: CupsPage
    }
  ],
  [
    Pages.ProductsMin,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faClipboard,
      path: NonAuthRoutes.ProductData,
      component: ProductDataPage
    }
  ],
  [
    Pages.ConceptsMin,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faClipboardList,
      path: NonAuthRoutes.Concept,
      component: ConceptPage
    }
  ],

  // Paquete 2
  [
    Pages.Mayoristas,
    {
      resource: [Resources.Trades],
      icon: faIndustry,
      path: NonAuthRoutes.Wholesaler,
      component: ConsultationPage
    }
  ],
  [
    Pages.CounterpartiesEdit,
    {
      resource: [Resources.Trades],
      icon: faUserTie,
      path: NonAuthRoutes.partnersEdit,
      component: PartnerEditPage
    }
  ],
  [
    Pages.Counterparties,
    {
      resource: [Resources.Trades],
      icon: faUserTie,
      path: NonAuthRoutes.partners,
      component: PartnerPage
    }
  ],
  [
    Pages.ProductsMay,
    {
      resource: [Resources.Trades],
      icon: faClipboard,
      path: NonAuthRoutes.ProductMay,
      component: MarketerPage
    }
  ],
  [
    Pages.ConceptsMay,
    {
      resource: [Resources.Trades],
      icon: faClipboardList,
      path: NonAuthRoutes.Trader,
      component: TraderPage
    }
  ],
  // Paquete 3
  [
    Pages.CommercialEdit,
    {
      resource: [Resources.Commercial],
      icon: faUserTag,
      path: NonAuthRoutes.CommercialEdit,
      component: CommercialEditPage
    }
  ],
  [
    Pages.Commercial,
    {
      resource: [Resources.Commercial],
      icon: faUserTag,
      path: NonAuthRoutes.Commercial,
      component: CommercialPage
    }
  ],
  [
    Pages.Commercials,
    {
      resource: [Resources.Commercial],
      icon: faUserTag,
      path: NonAuthRoutes.clients,
      component: CommercialPage
    }
  ],
  [
    Pages.CommercialsDetails,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.CommercialsDetails,
      component: CommercialDetailsPage
    }
  ],
  [
    Pages.ProductsCom,
    {
      resource: [Resources.Commercial],
      icon: faClipboard,
      path: NonAuthRoutes.ProductDataCommercial,
      component: CommercialsProductDataPage
    }
  ],
  [
    Pages.ConceptsCom,
    {
      resource: [Resources.Commercial],
      icon: faClipboardList,
      path: NonAuthRoutes.ConceptCommercial,
      component: CommercialsConceptPage
    }
  ],
  // Paquete 4

  [
    Pages.Guarantee,
    {
      resource: [Resources.Guarantee],
      icon: faStamp,
      path: NonAuthRoutes.Guarantee,
      component: AtrDistributionPage
    }
  ],
  [
    Pages.Gbalance,
    {
      resource: [Resources.Guarantee],
      icon: faBalanceScaleRight,
      path: NonAuthRoutes.UnbalancedGuarantees,
      component: UnbalancedGuaranteesPage
    }
  ],
  [
    Pages.Gatr,
    {
      resource: [Resources.Guarantee],
      icon: faWaveSquare,
      path: NonAuthRoutes.AtrDistribution,
      component: AtrDistributionPage
    }
  ],
  [
    Pages.InfoTSO,
    {
      resource: [Resources.InfoTSO],
      icon: faInfo,
      path: NonAuthRoutes.InfoTso,
      component: ConsultationInformationPage
    }
  ],

  [
    Pages.MassiveProcess,
    {
      resource: [Resources.massiveProcess],
      icon: faBoxes,
      path: NonAuthRoutes.MassiveProcess,
      component: ConsultationInformationPage
    }
  ],

  [
    Pages.MPDemand,
    {
      resource: [Resources.massiveProcess],
      icon: faFileContract,
      path: NonAuthRoutes.DemandLoad,
      component: DemandLoadPage
    }
  ],
  [
    Pages.MPContracts,
    {
      resource: [Resources.massiveProcess],
      icon: faFileMedicalAlt,
      path: NonAuthRoutes.ContractsLoad,
      component: ContractsLoadPage
    }
  ],
  [
    Pages.TemplateSettingsEdit,
    {
      resource: [Resources.TemplateSettings],
      icon: faObjectGroup,
      path: NonAuthRoutes.TemplateSettingsEdit,
      component: TemplateSettingsEditPage
    }
  ],
  [
    Pages.TemplateSettingsAdd,
    {
      resource: [Resources.TemplateSettings],
      icon: faObjectGroup,
      path: NonAuthRoutes.TemplateSettingsAdd,
      component: TemplateSettingsAddPage
    }
  ],
  [
    Pages.TemplateSettings,
    {
      resource: [Resources.TemplateSettings],
      icon: faObjectGroup,
      path: NonAuthRoutes.TemplateSettings,
      component: TemplateSettingsPage
    }
  ],
  [
    Pages.ManualInvoice,
    {
      resource: [Resources.InvoicesPage],
      icon: faPenSquare,
      path: NonAuthRoutes.ManualInvoice,
      component: ManualInvoicePage
    }
  ],
  [
    Pages.ContractsAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractAdd,
      component: ContractAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractsEdit,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractEdit,
      component: ContractEditPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractCapacities,
    {
      resource: [Resources.ComunicationsCenterProcedures],
      path: NonAuthRoutes.ContractCapacities,
      component: ContractCapacitiesPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractDetails,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractDetails,
      component: ContractDetailsPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractQuantities,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractQuantities,
      component: ContractQuantitiesPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractFlexibilities,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractFlexibilities,
      component: ContractsFlexibilitiesPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractPriceComponents,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractPriceComponents,
      component: ContractsPriceComponentsPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractChangeOwnerPage,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractChangeOwner,
      component: ContractChangeOwnerPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContractOrdersPage,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContractOrders,
      component: ContractOrdersPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ClientsSearch,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ClientSearch,
      component: ClientsSearchPage
      // userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ClientAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ClientAdd,
      component: ClientAddPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ClientEdit,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ClientEdit,
      component: ClientEditPage
      // userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ContactsInfo,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ContactInfo,
      component: ContactsInfoPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.AddressInfo,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.AddressInfo,
      component: AddressInfoPage,
      userPermission: UserPermission.EDIT
    }
  ],
  [
    Pages.ClientFile,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ClientFile,
      component: ClientFile
    }
  ],
  [
    Pages.Client,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      icon: faUserFriends,
      path: NonAuthRoutes.Client,
      component: ClientPage
    }
  ],
  [
    Pages.ProceduresAdd,
    {
      resource: [Resources.ComunicationsCenterProcedures],
      path: NonAuthRoutes.ProceduresAdd,
      component: AddProcedurePage
    }
  ],
  [
    Pages.GeneratorTest,
    {
      resource: [Resources.ComunicationsCenterProcedures],
      path: NonAuthRoutes.GeneratorTest,
      component: GeneratorTest
    }
  ],
  [
    Pages.PriceComponentsAdd,
    {
      resource: [Resources.Pricing], // Temporarly
      icon: faGroupArrowsRotate,
      path: NonAuthRoutes.PriceComponentsAdd,
      component: PriceComponentsAddPage
    }
  ],
  [
    Pages.PriceComponents,
    {
      resource: [Resources.Flexibility], // Temporarly
      path: NonAuthRoutes.PriceComponents,
      component: PriceComponentsPage
    }
  ],
  [
    Pages.SettlementGroupChild,
    {
      resource: [Resources.ExtendedClients],
      path: NonAuthRoutes.SettlementGroupChild,
      component: ChildSettlementGroupPage
    }
  ],
  [
    Pages.SettlementGroupFlexibilities,
    {
      resource: [Resources.Flexibility], // Temporarly
      path: NonAuthRoutes.SettlementGroupFlexibilities,
      component: SettlementGroupFlexibilitiesPage
    }
  ],
  [
    Pages.SettlementGroupContracts,
    {
      resource: [Resources.Flexibility],
      path: NonAuthRoutes.SettlementGroupContracts,
      component: SettlementGroupContractsPage
    }
  ],
  [
    Pages.SettlementGroupSubjects,
    {
      resource: [Resources.Flexibility],
      path: NonAuthRoutes.SettlementGroupSubjects,
      component: SettlementGroupSubjectsPage
    }
  ],
  [
    Pages.SettlementGroupAggregatedAdd,
    {
      resource: [Resources.GroupedBilling],
      path: NonAuthRoutes.SettlementGroupAggregatedAdd,
      component: SettlementGroupAggregatedAddPage
    }
  ],
  [
    Pages.SettlementGroupAggregatedEdit,
    {
      resource: [Resources.GroupedBilling],
      path: NonAuthRoutes.SettlementGroupAggregatedEdit,
      component: SettlementGroupAggregatedEditPage
    }
  ],
  [
    Pages.SettlementGroups,
    {
      resource: [Resources.Flexibility, Resources.GroupedBilling, Resources.VirtualBattery],
      icon: faGroupArrowsRotate,
      path: NonAuthRoutes.SettlementGroups,
      component: SettlementGroupsPage
    }
  ],
  [
    Pages.ProductsCustomize,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ProductsCustomize,
      component: CustomizeProductPage
    }
  ],
  [
    Pages.ProductsPrice,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ProductsPrice,
      component: ProductsPriceComponentsPage
    }
  ],
  [
    Pages.ProductsEdit,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ProductsEdit,
      component: ProductsEditPage
    }
  ],
  [
    Pages.ProductsAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ProductsAdd,
      component: ProductsAddPage
    }
  ],
  [
    Pages.Products,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.Products,
      component: ProductsPage
    }
  ],
  [
    Pages.Documents,
    {
      resource: [Resources.Client, Resources.ExtendedClients, Resources.Trades],
      path: NonAuthRoutes.Documents,
      component: DocumentsPage
    }
  ],
  [
    Pages.ConceptsAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ConceptsAdd,
      component: ConceptsAddPage
    }
  ],
  [
    Pages.ConceptsEdit,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ConceptsEdit,
      component: ConceptEditPage
    }
  ],
  [
    Pages.ConceptsModifiedAdd,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.ConceptsModifiedAdd,
      component: ConceptModifiedAddPage
    }
  ],
  [
    Pages.Concepts,
    {
      resource: [Resources.Client, Resources.ExtendedClients],
      path: NonAuthRoutes.Concepts,
      component: ConceptsPage
    }
  ],
  [
    Pages.LeadsProfileDetail,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsProfileDetail,
      component: LeadsProfileDetailPage
    }
  ],
  [
    Pages.LeadsConsumptionProfile,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsConsumptionProfile,
      component: LeadsConsumptionProfilePage
    }
  ],
  [
    Pages.LeadsFile,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsFile,
      component: LeadsFilePage
    }
  ],
  [
    Pages.LeadsReport,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsReport,
      component: LeadsReportPage
    }
  ],
  [
    Pages.LeadsEdit,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsEdit,
      component: LeadsEditPage
    }
  ],
  [
    Pages.LeadsAdd,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.LeadsAdd,
      component: LeadsAddPage
    }
  ],
  [
    Pages.Leads,
    {
      resource: [Resources.Leads],
      icon: faUserPlus,
      path: NonAuthRoutes.Leads,
      component: LeadsPage
    }
  ],
  [
    Pages.QuotesProducts,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.QuotesProducts,
      component: QuotesProductsPage
    }
  ],
  [
    Pages.Quotes,
    {
      resource: [Resources.Leads],
      path: NonAuthRoutes.Quotes,
      component: QuotesPage
    }
  ],
  [
    Pages.TaskEdit,
    {
      resource: [Resources.Tasks],
      path: NonAuthRoutes.TasksEdit,
      component: TaskEditPage
    }
  ],
  [
    Pages.TaskAdd,
    {
      resource: [Resources.Tasks],
      path: NonAuthRoutes.TasksAdd,
      component: TaskAddPage
    }
  ],
  [
    Pages.Tasks,
    {
      resource: [Resources.Tasks],
      icon: faListCheck,
      path: NonAuthRoutes.Tasks,
      component: TasksPage
    }
  ],
  [
    Pages.ProfilesEdit,
    {
      resource: [Resources.InvoicesPage, Resources.Leads],
      path: NonAuthRoutes.ProfilesEdit,
      component: ProfileEditPage
    }
  ],
  [
    Pages.Profiles,
    {
      resource: [Resources.InvoicesPage, Resources.Leads],
      icon: faBoltLightning,
      path: NonAuthRoutes.Profiles,
      component: ProfilesPage
    }
  ],
  [
    Pages.Documentos,
    {
      resource: [Resources.AtlasDocumentos],
      icon: faFileLines,
      path: NonAuthRoutes.AtlasDocuments,
      component: AtlasDocumentsPage
    }
  ],
  [
    Pages.AccessAtlas,
    {
      resource: [Resources.AtlasDocumentos],
      icon: faUserCog,
      path: NonAuthRoutes.AccessAtlas,
      component: AtlasAccessPage
    }
  ],
  [
    Pages.BlogAdd,
    {
      resource: [Resources.AtlasDocumentos],
      path: NonAuthRoutes.AtlasBlogAdd,
      component: AtlasBlogEditorPage
    }
  ],
  [
    Pages.BlogEdit,
    {
      resource: [Resources.AtlasDocumentos],
      path: NonAuthRoutes.AtlasBlogEdit,
      component: AtlasBlogEditorPage
    }
  ],
  [
    Pages.AtlasBlog,
    {
      resource: [Resources.AtlasDocumentos],
      icon: faBlog,
      path: NonAuthRoutes.AtlasBlog,
      component: AtlasBlogPage
    }
  ],
  [
    Pages.Atlas,
    {
      resource: [Resources.AtlasDocumentos],
      icon: faAtlas,
      path: NonAuthRoutes.Atlas,
      component: AtlasDocumentsPage
    }
  ]
])
